export const pageSize = 14;

export const barWidth = 160;
export const barHeight = 16;
